import { getTrackIdentifiersDetails } from '../services/accountService'

function fetchFollowRequestDetails(accountNumber, order) {
  return getTrackIdentifiersDetails(accountNumber, order)
}

export default fetchFollowRequestDetails



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/fetchFollowRequestDetails.js